module.exports = __webpack_public_path__ + "img/logoPremiumNavBar.svg";